module.exports = __webpack_public_path__ + "static/media/spaghettiwithgarlic,chilliandparsley.43cec8b6.jpg";